module.exports = __webpack_public_path__ + "static/media/loading.b32f9858.svg";